import ReactPDF, { View } from "@react-pdf/renderer";
import * as React from "react";
import { Nullable } from "../../../../../types/utils";
import { User } from "../../../../entities/User";
import {
  OrderCategory,
  OrderCostingVersion,
  OrderStatus,
  TOrderCostV2,
  TOrderCostV3,
  TOrderCostV4, TOrderCostV5
} from "../../../../api/endpoints/Order";
import VolumeSummary from "././VolumeSummary";
import InformationCost from "./InformationCost";
import ServiceChargeCost from "./ServiceChargeCost";
import TotalCost from "./TotalCost";
import CostingVersion from "././CostingVersion";

interface IProps {
  user: User;
  styles: ReactPDF.Styles;
  cost: TOrderCostV2 | TOrderCostV3 | TOrderCostV4 | TOrderCostV5;
  currentCostingVersion?: Nullable<OrderCostingVersion>;
  orderCategory: OrderCategory;
  orderStatus: OrderStatus;
  annualTotalCostFootnoteRef?: string;
}

export interface OrderCostSummaryV2PdfProps extends IProps {
}

const OrderCostSummaryPdfV2 = (props: IProps) => {
  const { cost, orderCategory } = props;
  const { total_cost } = cost.data;

  if (!total_cost) {
    return null;
  }

  return (
    <View>

      {
        (orderCategory === OrderCategory.REALTIME || orderCategory === OrderCategory.EU_CUTOUT) &&
        <VolumeSummary {...props} />
      }

      {
        orderCategory !== OrderCategory.ARCHIVE &&
        <InformationCost {...props} />
      }

      <ServiceChargeCost {...props} />

      <TotalCost {...props} />

      <CostingVersion {...props} />
    </View>
  )
}

export default OrderCostSummaryPdfV2;
